import React from 'react';
import { LuArrowDown, LuArrowUp, LuArrowUpDown } from 'react-icons/lu';
import { cx } from '../../utils/cx.js';

// Insights table look: small uppercase header on a tinted row, hairline rows, hover tint.
export const Table = ({ className = '', children }) => (
  <div className="overflow-x-auto">
    <table className={cx('min-w-full text-left text-sm', className)}>{children}</table>
  </div>
);

export const THead = ({ children }) => (
  <thead className="border-b border-gray-100 bg-gray-50/80 text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:border-gray-900 dark:bg-night-850 dark:text-gray-400">
    <tr>{children}</tr>
  </thead>
);

export const Th = ({ className = '', children, ...rest }) => (
  <th scope="col" className={cx('whitespace-nowrap px-4 py-2.5 font-semibold sm:px-5', className)} {...rest}>{children}</th>
);

/** Sortable column header: the whole label is the button, aria-sort tells the current order. */
export const SortTh = ({ column, sort, onSort, className = '', children }) => {
  const active = sort?.key === column;
  const Icon = !active ? LuArrowUpDown : sort.direction === 'asc' ? LuArrowUp : LuArrowDown;
  return (
    <th
      scope="col"
      aria-sort={active ? (sort.direction === 'asc' ? 'ascending' : 'descending') : 'none'}
      className={cx('whitespace-nowrap px-4 py-1.5 sm:px-5', className)}
    >
      <button
        type="button"
        onClick={() => onSort(column)}
        className={cx(
          '-mx-1.5 inline-flex cursor-pointer items-center gap-1 rounded-md px-1.5 py-1 font-semibold uppercase tracking-wider outline-none hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-brand-500 dark:hover:text-white',
          active && 'text-brand-600 dark:text-brand-400',
        )}
      >
        {children}
        <Icon className={cx('h-3.5 w-3.5', !active && 'opacity-40')} aria-hidden />
      </button>
    </th>
  );
};

export const TBody = ({ children }) => (
  <tbody className="divide-y divide-gray-100 dark:divide-gray-900">{children}</tbody>
);

export const Tr = ({ className = '', children, ...rest }) => (
  <tr className={cx('transition-colors hover:bg-gray-50/80 dark:hover:bg-white/[0.02]', className)} {...rest}>{children}</tr>
);

export const Td = ({ className = '', children, ...rest }) => (
  <td className={cx('px-4 py-3 align-middle text-gray-600 dark:text-gray-300 sm:px-5', className)} {...rest}>{children}</td>
);
